export default __webpack_public_path__ + "static/media/mimgCita-min.2451b78f.jpg";